/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandPepsi = createReactComponent("brand-pepsi", "IconBrandPepsi", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M4 16c5.713 -2.973 11 -3.5 13.449 -11.162", key: "svg-1" }],
  ["path", { d: "M5 17.5c5.118 -2.859 15 0 14 -11", key: "svg-2" }]
]);

export { IconBrandPepsi as default };
//# sourceMappingURL=IconBrandPepsi.js.map
